<template>
  <form>
    <div class="md-layout">
      <div class="md-layout-item md-small-size-100 md-size-20">
        <form-group label="Title" :validator-object="$v.user.title">
          <template v-slot:input>
            <md-select
              id="title"
              v-model="$v.user.title.$model"
              name="title"
              md-dense
            >
              <md-option value="Mr">Mr</md-option>
              <md-option value="Mrs">Mrs</md-option>
              <md-option value="Miss">Miss</md-option>
              <md-option value="Ms">Ms</md-option>
            </md-select>
          </template>
        </form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-40">
        <form-group
          label="First Name"
          input-type="text"
          :validator-object="$v.user.firstName"
        ></form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-40">
        <form-group
          label="Last Name"
          input-type="text"
          :validator-object="$v.user.lastName"
        ></form-group>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-50">
        <form-group
          label="Mobile Number"
          input-type="tel"
          :validator-object="$v.user.phone"
        ></form-group>
      </div>
      <div class="md-layout-item">
        <md-datepicker
          v-model="$v.user.dob.$model"
          v-mask="'##/##/####'"
          :class="{ 'md-invalid': $v.user.dob.$error }"
          :md-open-on-focus="false"
          pattern="\d{2}/\d{2}/\d{4}"
          style="margin-bottom: 0.5em"
        >
          <label>Date of Birth</label>
          <span v-if="!$v.user.dob.required" class="md-error"
            >Field is required</span
          >
        </md-datepicker>
        <span class="d-inline-block text-sm text-muted">dd/mm/yyyy</span>
      </div>
      <div class="md-layout-item md-small-size-100 md-size-100">
        <form-group
          label="Email Address"
          input-type="email"
          :validator-object="$v.user.email"
        ></form-group>
      </div>
      <div class="md-layout-item md-size-100 d-flex align-items-center">
        <md-button
          class="md-primary mt-3"
          :disabled="loading"
          @click="submit()"
        >
          Register
        </md-button>
        <md-progress-spinner
          class="mx-3"
          :md-diameter="30"
          :md-stroke="loading ? 4 : 0"
          md-mode="indeterminate"
        ></md-progress-spinner>
      </div>
    </div>
  </form>
</template>
<script>
import ApiService from "@/services/api";
import userModel from "@/models/user";
import FormGroup from "@/components/Forms/FormGroup";
import { email, required } from "vuelidate/lib/validators";
import { toastLaravelErrors } from "@/mixins";

export default {
  name: "RegistrationForm",
  components: { FormGroup },
  mixins: [toastLaravelErrors],
  data() {
    return {
      user: Object.assign({}, userModel),
      business: {},
      businessTypes: [],
      loading: false,
    };
  },
  validations: {
    user: {
      title: {
        required,
      },
      firstName: {
        required,
      },
      lastName: {
        required,
      },
      phone: {
        required,
      },
      email: {
        required,
        email,
      },
      dob: {
        required,
      },
    },
  },
  created() {
    ApiService.auth.setCSRF();
    ApiService.business.getTypes().then((response) => {
      this.businessTypes = response.data.data.business_types;
    });

    this.copyLoginData();
  },
  methods: {
    copyLoginData() {
      if (this.$route.query.d && this.$route.query.t) {
        if (this.$route.query.t === "sms") {
          this.user.phone = this.$route.query.d;
        } else if (this.$route.query.t === "email") {
          this.user.email = this.$route.query.d;
        }
      } else if (localStorage.user) {
        const storedUser = JSON.parse(localStorage.user);
        this.user.firstName = storedUser.first_name;
        this.user.lastName = storedUser.last_name;
        this.user.email = storedUser.email;
        this.user.phone = storedUser.mobile_number;
      }
    },
    submit() {
      if (!this.validate()) return;

      this.loading = true;

      const userData = {
        title: this.user.title,
        first_name: this.user.firstName,
        last_name: this.user.lastName,
        email: this.user.email,
        mobile_number: this.user.phone,
        dob: this.$moment(this.user.dob, "DD/MM/YYYY").format("YYYY-MM-DD"),
      };

      ApiService.auth
        .register(userData)
        .then(() => {
          localStorage.removeItem("user");
          this.$router.push({
            path: "/login",
            query: { reg: "true", l: this.user.phone ?? this.user.email },
          });
        })
        .catch((error) => {
          this.toastLaravelErrors(error);

          if (error.response.status === 409) {
            const msg =
              "The given email and/or mobile number is already in use.";
            this.$toast.error(msg);
          } else {
            this.$toast.error(error.response.data.message);
          }
        })
        .finally(() => {
          this.loading = false;
        });
    },
    validate() {
      this.$v.$touch();
      return !this.$v.$invalid;
    },
  },
};
</script>
<style></style>
